import { coreApi } from "./coreApi";

export const permissionsApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getFinancialAccounts: builder.query({
      query: (page) => `/accounting/accounts?per_page=100&page=${page}`,
      providesTags: ["FinancialAccount"],
    }),
    getSingleFinancialAccount: builder.query({
      query: (id) => `/accounting/accounts/show/${id}`,
    }),
    createFinancialAccount: builder.mutation({
      query: (account) => ({
        url: "/accounting/accounts",
        method: "POST",
        body: account,
      }),
      invalidatesTags: ["FinancialAccount"],
    }),
    updateFinancialAccount: builder.mutation({
      query: (account) => ({
        url: `/accounting/accounts/update/${account.id}`,
        method: "PUT",
        body: account,
      }),
      invalidatesTags: ["FinancialAccount"],
    }),
    deleteFinancialAccount: builder.mutation({
      query: (id) => ({
        url: `/accounting/accounts/delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["FinancialAccount"],
    }),
    getAccountsTree: builder.query({
      query: () => "/accounting/accounts/tree",
    }),
    getAccountsTypes: builder.query({
      query: () => "/accounting/accounts/create",
    }),
  }),
});

export const {
  useGetFinancialAccountsQuery,
  useLazyGetFinancialAccountsQuery,
  useGetSingleFinancialAccountQuery,
  useCreateFinancialAccountMutation,
  useUpdateFinancialAccountMutation,
  useDeleteFinancialAccountMutation,
  useGetAccountsTreeQuery,
  useGetAccountsTypesQuery,
} = permissionsApi;

export default permissionsApi;
